'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-intl/~/intl-messageformat/~/intl-messageformat-parser/index.js
 ** module id = 45
 ** module chunks = 0
 **/